/**
 *
 * Asynchronously loads the component for Candidati
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/CandidatesArea/Loadable.js